<template>
  <div class="main">
    <c-panel title="Bibliotecas do município" titleIcon="fas fa-university">
      <!--
        Item 7 do edital: "cadastro de bibliotecas, possibilitando manter os dados cadastrais
        das bibliotecas do município". Ao contrário dos catálogos, é INSTITUCIONAL: a lista já
        vem recortada pelo escopo do usuário — o backend não aceita instituição fora dele.
      -->
      <el-row :gutter="10" class="u-mt-10 u-mb-20">
        <el-col :xs="24" :sm="8">
          <el-input v-model="filtro.termo" placeholder="Pesquisar por nome" clearable
                    @keyup.native.enter="load" @clear="load"></el-input>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-select v-model="filtro.instituicao_id" placeholder="Instituição" clearable
                     @change="load" style="width:100%" filterable>
            <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="8" class="u-text-right">
          <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
          <el-button v-if="podeEscrever" type="primary" icon="el-icon-plus" @click="abrirNovo">NOVA BIBLIOTECA</el-button>
        </el-col>
      </el-row>

      <div class="container-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="hidden-mobile" style="width:70px;">cod</th>
              <th>Nome</th>
              <th class="hidden-mobile">Instituição</th>
              <th class="hidden-mobile" style="width:170px;">Responsável</th>
              <th class="hidden-mobile" style="width:140px;">Telefone</th>
              <th class="hidden-mobile u-text-center" style="width:80px;">Ativa</th>
              <th style="width:130px;" class="u-text-center" v-if="podeEscrever">Ação</th>
            </tr>
          </thead>
          <tbody v-if="statusList">
            <tr v-for="b in items" :key="b.id">
              <td class="hidden-mobile">{{ b.id }}</td>
              <td>{{ b.nome }}</td>
              <td class="hidden-mobile">{{ b.instituicao_nome || '—' }}</td>
              <td class="hidden-mobile">{{ b.responsavel || '—' }}</td>
              <td class="hidden-mobile">{{ b.telefone || '—' }}</td>
              <td class="hidden-mobile u-text-center">{{ b.situacao ? 'SIM' : 'NÃO' }}</td>
              <td class="u-text-center acao" v-if="podeEscrever">
                <el-button @click="abrirEdicao(b)" title="Editar" type="info" icon="el-icon-edit"
                           size="mini" plain class="u-mr-10"></el-button>
                <el-button @click="excluir(b)" title="Excluir" type="danger" icon="el-icon-delete"
                           size="mini" plain></el-button>
              </td>
            </tr>
            <tr v-if="items.length === 0">
              <td :colspan="podeEscrever ? 7 : 6" class="u-text-center">Nenhuma biblioteca encontrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-dialog :title="editandoId ? 'Editar biblioteca' : 'Nova biblioteca'"
                 :visible.sync="dialogAberto" width="640px" append-to-body>
        <el-form :model="form" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Instituição *">
                <el-select v-model="form.instituicao_id" placeholder="Instituição" style="width:100%"
                           filterable :disabled="!!editandoId">
                  <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                </el-select>
                <small v-if="editandoId" class="u-fs-12">
                  A instituição não muda depois de criada: as seções e o acervo já apontam para ela.
                </small>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Nome *"><el-input v-model="form.nome" maxlength="191"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Responsável"><el-input v-model="form.responsavel" maxlength="191"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Telefone"><el-input v-model="form.telefone" maxlength="20"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="E-mail"><el-input v-model="form.email" maxlength="191"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Horário de funcionamento">
                <el-input v-model="form.horario_funcionamento" maxlength="191"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Ativa"><el-switch v-model="form.situacao"></el-switch></el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogAberto = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="salvar" :loading="salvando">SALVAR</el-button>
        </span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    statusList: false,
    items: [],
    instituicoes: [],
    filtro: { termo: '', instituicao_id: '' },
    dialogAberto: false,
    salvando: false,
    editandoId: null,
    form: {}
  }),
  computed: {
    // Espelho da matriz do backend (Diretor, NTI-PMVC, NTI-SMED, Vice). O Service decide.
    podeEscrever () { return [1, 4, 5, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    base () { return `${this.$store.state.config.baseUrlApi}/api/biblioteca/unidade` }
  },
  mounted () { this.instituicoes = this.$store.state.instituicoes || []; this.load() },
  methods: {
    load () {
      this.statusList = false
      this.$axios.post(`${this.base}/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) {
            this.statusList = true
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }
          this.items = r.data.data || []
          this.statusList = true
        }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },
    abrirNovo () {
      this.editandoId = null
      this.form = { instituicao_id: '', nome: '', responsavel: '', telefone: '', email: '',
                    horario_funcionamento: '', situacao: true }
      this.dialogAberto = true
    },
    abrirEdicao (b) {
      this.editandoId = b.id
      this.form = {
        instituicao_id: b.instituicao_id, nome: b.nome, responsavel: b.responsavel || '',
        telefone: b.telefone || '', email: b.email || '',
        horario_funcionamento: b.horario_funcionamento || '', situacao: !!b.situacao
      }
      this.dialogAberto = true
    },
    salvar () {
      if (!this.form.nome || !this.form.instituicao_id) {
        return window.eventBus.$emit('alert', { msg: 'Informe a instituição e o nome.', type: 'warning' })
      }
      this.salvando = true
      const url = this.editandoId ? `${this.base}/update/${this.editandoId}` : `${this.base}/store`
      this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogAberto = false
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.load()
        }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },
    excluir (b) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta biblioteca?', 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.base}/delete/${b.id}`, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    }
  }
}
</script>
